import React, {useContext, useState} from 'react'
import {saveRoleObject} from "../../../../services/api/apiSwagger";
import {message} from "antd";
import parseToken from "../../../../helpers/parseToken";
import {SettingRoleContext} from "../../context/SettingRoleContext";

function SaveRolesFunction(props) {
    const {arrSelected} = props
    const SettingRolePageContext = useContext(SettingRoleContext)
    const {roleSelected, setFilters, fetchListRoleFunction} = SettingRolePageContext
    const [loading, setLoading] = useState(false)
    const decodeToken = parseToken()

    const _saveRoleFunction = async () => {
        setLoading(true)
        try {
            const payload = {
                objectIds: arrSelected,
                roleId: parseInt(roleSelected[0])
            }
            const response = await saveRoleObject(decodeToken.sub, payload)

            const {success, error_message: error} = response

            if (success !== '1') {
                setLoading(false)
                return message.error(error)
            }

            fetchListRoleFunction()
            setFilters({description: ''})
            message.success('Lưu dữ liệu thành công!')
            setLoading(false)
        } catch (e) {
            setLoading(false)
            message.error(e.message)
        }
    }

    return <div className="SaveRolesFunction">
        <button disabled={loading} onClick={_saveRoleFunction} className="ButtonCustom mr-3">Save</button>
    </div>
}

export default SaveRolesFunction
